import { ReactNode, useEffect, useRef } from 'react'

/** A modal dialog: focus moves in, Escape closes, the page behind can't scroll */
export function Dialog({
  labelledBy,
  onClose,
  alert,
  className = 'dialog small',
  center = true,
  children,
}: {
  labelledBy: string
  onClose: () => void
  alert?: boolean
  className?: string
  center?: boolean
  children: ReactNode
}) {
  const ref = useRef<HTMLDivElement>(null)
  const close = useRef(onClose)
  close.current = onClose
  useEffect(() => {
    const before = document.activeElement as HTMLElement | null
    const first = ref.current?.querySelector<HTMLElement>('button, a[href], input, textarea')
    first?.focus()
    const onKey = (e: KeyboardEvent) => e.key === 'Escape' && close.current()
    document.addEventListener('keydown', onKey)
    const overflow = document.body.style.overflow
    document.body.style.overflow = 'hidden'
    return () => {
      document.removeEventListener('keydown', onKey)
      document.body.style.overflow = overflow
      before?.focus?.()
    }
  }, [])
  return (
    <div className={center ? 'scrim center' : 'scrim'} onMouseDown={(e) => e.target === e.currentTarget && onClose()}>
      <div ref={ref} className={className} role={alert ? 'alertdialog' : 'dialog'} aria-modal="true" aria-labelledby={labelledBy}>
        {children}
      </div>
    </div>
  )
}
